import {
  LearnerProfile,
  LearnerProfileRepository,
} from '@/domain/precon-supporter';

/**
 * アドバンスト編受講希望設定ユースケース
 */
export class SetWantsAdvancedCourseUseCase {
  constructor(private readonly repository: LearnerProfileRepository) {}

  /**
   * アドバンスト編受講希望を設定
   * @param wants - true: 受講したい、false: 受講しない
   */
  async execute(wants: boolean): Promise<void> {
    let profile = await this.repository.find();
    if (!profile) {
      profile = LearnerProfile.create();
    }

    const updated = profile.setWantsAdvancedCourse(wants);
    await this.repository.save(updated);
  }
}
